var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBackActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 42,
    viewBox: "0 0 67 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66 41V42H67V41H66ZM66 1H67V0H66V1ZM6 1V0H5V1H6ZM6 20.3103L11.7735 10.3103H0.226497L6 20.3103ZM26 42H66V40H26V42ZM67 41V1H65V41H67ZM66 0H6V2H66V0ZM5 1V11.3103H7V1H5Z",
    fill: "#2E90FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackActive);
export default __webpack_public_path__ + "static/media/arrow-back-active.02f5658417e5a644e70df8445843d0bf.svg";
export { ForwardRef as ReactComponent };